var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('span',{staticClass:"tag is-success"},[_c('i',{staticClass:"fas fa-check"}),_vm._v(" "+_vm._s(_vm.$t('yes'))+" ")]):_c('span',{staticClass:"tag is-danger"},[_c('i',{staticClass:"fas fa-times"}),_vm._v(" "+_vm._s(_vm.$t('no'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }